document.addEventListener('DOMContentLoaded', function () {
    // Wait for tippy to be fully loaded
    function initTooltips() {
        if (typeof tippy !== 'undefined' && typeof Popper !== 'undefined') {
            try {
                tippy('.crossed-price-description', {
                    content(reference) {
                        return reference.getAttribute('data-tooltip-content') || '';
                    },
                    placement: 'top',
                    arrow: true,
                    animation: 'fade',
                    duration: [200, 150],
                    zIndex: 9999,
                    appendTo: document.body,
                    interactive: false,
                    trigger: 'mouseenter focus',
                    onShow(instance) {
                        // Prevent event bubbling to parent elements
                        instance.reference.addEventListener('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });
                    },
                });
            } catch (error) {
                console.warn('Tippy initialization failed:', error);
            }
        } else {
            // Retry after a short delay if libraries aren't loaded yet
            setTimeout(initTooltips, 100);
        }
    }

    initTooltips();

    // Also try again after a delay in case elements are loaded dynamically
    setTimeout(() => {
        initTooltips();
    }, 2000);
});